export const ADD_PREVIEW = 'preview/ADD_PREVIEW'
export const ADD_ID = 'preview/ADD_ID'
export const DELETE_ID = 'preview/DELETE_ID'
export const DELETE_PREVIEW = 'preview/DELETE_PREVIEW'
